import MailIcon from "../../background/mail_icon.png";
import ArrowUp from "../../assets/arrowUp.svg"
import "./style.css"

const Footer = () => {
    return <>
        <div className='footer-panel'>
            <img className='arrowUp' src={ArrowUp} />
            <div className='footer-panel-content'>
                <div className='footer-contact-us'>
                    <p className='footer-contact-text font-h'> РОБОТ-КАРТОГРАФ</p>
                    <div className='footer-contact-table'>
                        <div className='footer-contact-img-cont'>
                            <img src={MailIcon} alt='contactus' className="footer-contact-icon" />
                        </div>
                        <div className='footer-contact-elements'>
                            <div className='footer-contact-element'>
                                <p className='footer-contact-name font-footer'> Свяжитесь с нами</p>
                                <p className='footer-contact-number'> <a href="tel:+78462556371">+ 7 (846) 255-63-71</a></p>
                            </div>
                            <div className='footer-contact-element'>
                                <p className='footer-contact-name font-footer'> Электронный адрес</p>
                                <p className='footer-contact-number'> <a href="mailto:team@geosamara.ru">team@geosamara.ru</a></p>
                            </div>
                            <div className='footer-contact-element'>
                                {/* <p className='footer-contact-name font-desc'> Aдрес </p> */}
                                <p className='footer-contact-name font-footer address'> Самара, проспект Карла Маркса, дом 192, офис 717</p>
                            </div>
                        </div>
                    </div>
                </div>
                <p className='footer-name-org'>© АО «Самара-Информспутник»</p>
            </div>
        </div>
    </>
}

export default Footer;